/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CtiosRequestSource = 'PARCEL_DETAIL' | 'PARCEL_LIST' | 'AUTOMATIC_UPDATE' | 'MANUAL_UPDATE';

export const CtiosRequestSource = {
    PARCEL_DETAIL: 'PARCEL_DETAIL' as CtiosRequestSource,
    PARCEL_LIST: 'PARCEL_LIST' as CtiosRequestSource,
    AUTOMATIC_UPDATE: 'AUTOMATIC_UPDATE' as CtiosRequestSource,
    MANUAL_UPDATE: 'MANUAL_UPDATE' as CtiosRequestSource
};

